webpackJsonp([20],{

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1126);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(761)("c523c15c", content, true, {});

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(760)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.product-info-container[data-v-3d1a9c60]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:grid;grid-column-gap:20px}@media (min-width:600px){.product-info-container[data-v-3d1a9c60]{grid-template-columns:50px 1fr}}.table[data-v-3d1a9c60]{margin:0 50px}@media (max-width:600px){.table[data-v-3d1a9c60]{margin:0 10px}}.table tr[data-v-3d1a9c60]{background-color:red}.table tr td[data-v-3d1a9c60]{padding:10px 30px}@media (max-width:600px){.table tr td[data-v-3d1a9c60]{padding:10px 20px}}.row-product[data-v-3d1a9c60]{grid-column:1/3}@media (max-width:600px){.row-product[data-v-3d1a9c60]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f5f5f5;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%}}.product-name[data-v-3d1a9c60]{font-family:Avenir Next Bold;font-size:14px}@media (max-width:600px){.product-name[data-v-3d1a9c60]{font-size:12px}}@media (max-width:600px){.product-img[data-v-3d1a9c60]{display:none}}.product-unit-price[data-v-3d1a9c60]{grid-column:1;grid-row:2}@media (max-width:600px){.product-unit-price[data-v-3d1a9c60]{font-size:12px}}.product-date[data-v-3d1a9c60]{grid-column:2/4;grid-row:2;white-space:nowrap}@media (max-width:600px){.product-date[data-v-3d1a9c60]{font-size:12px;text-align:left}}.product-actions[data-v-3d1a9c60]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;grid-column:3;grid-row:1/3;height:65px;padding:10px 5px!important}@media (max-width:600px){.product-actions[data-v-3d1a9c60]{border-bottom:none;font-size:12px}}.product-actions-wrapper[data-v-3d1a9c60]{display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:600px){.row-product[data-v-3d1a9c60]{border:none}}.product-img[data-v-3d1a9c60]{height:34px;-o-object-fit:contain;object-fit:contain;width:50px}.action-btn[data-v-3d1a9c60]{margin:0 10px}.section-title[data-v-3d1a9c60]{font-family:Avenir Next Bold;font-size:16px;margin:30px 0 40px 40px;text-transform:uppercase}@media (max-width:500px){.section-title[data-v-3d1a9c60]{margin-bottom:20px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/profile/favorites.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,yCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,oBAAsB,CACvB,AACD,yBACA,yCACM,8BAAgC,CACrC,CACA,AACD,wBACE,aAAe,CAChB,AACD,yBACA,wBACM,aAAe,CACpB,CACA,AACD,2BACI,oBAAsB,CACzB,AACD,8BACM,iBAAmB,CACxB,AACD,yBACA,8BACU,iBAAmB,CAC5B,CACA,AACD,8BACE,eAAiB,CAClB,AACD,yBACA,8BACM,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAa,CAClB,CACA,AACD,+BACE,6BAAgC,AAChC,cAAgB,CACjB,AACD,yBACA,+BACM,cAAgB,CACrB,CACA,AACD,yBACA,8BACI,YAAc,CACjB,CACA,AACD,qCACE,cAAe,AACf,UAAY,CACb,AACD,yBACA,qCACM,cAAgB,CACrB,CACA,AACD,+BACE,gBAAiB,AACjB,WAAY,AACZ,kBAAoB,CACrB,AACD,yBACA,+BACM,eAAgB,AAChB,eAAiB,CACtB,CACA,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,aAAgB,AAChB,YAAa,AACb,0BAA6B,CAC9B,AACD,yBACA,kCACM,mBAAoB,AACpB,cAAgB,CACrB,CACA,AACD,0CACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,yBACA,8BACI,WAAa,CAChB,CACA,AACD,8BACE,YAAa,AACb,sBAAuB,AACpB,mBAAoB,AACvB,UAAY,CACb,AACD,6BACE,aAAe,CAChB,AACD,gCACE,6BAAgC,AAChC,eAAgB,AAChB,wBAAyB,AACzB,wBAA0B,CAC3B,AACD,yBACA,gCACM,kBAAoB,CACzB,CACA","file":"favorites.vue","sourcesContent":["\n@font-face {\n  font-family: 'Avenir Next Regular';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Ultra Light';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Ultra Light Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Medium';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Medium Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Demi';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi\"), url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Demi Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Bold';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Heavy';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Heavy Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Book';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n.product-info-container[data-v-3d1a9c60] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: grid;\n  grid-column-gap: 20px;\n}\n@media (min-width: 600px) {\n.product-info-container[data-v-3d1a9c60] {\n      grid-template-columns: 50px 1fr;\n}\n}\n.table[data-v-3d1a9c60] {\n  margin: 0 50px;\n}\n@media (max-width: 600px) {\n.table[data-v-3d1a9c60] {\n      margin: 0 10px;\n}\n}\n.table tr[data-v-3d1a9c60] {\n    background-color: red;\n}\n.table tr td[data-v-3d1a9c60] {\n      padding: 10px 30px;\n}\n@media (max-width: 600px) {\n.table tr td[data-v-3d1a9c60] {\n          padding: 10px 20px;\n}\n}\n.row-product[data-v-3d1a9c60] {\n  grid-column: 1/3;\n}\n@media (max-width: 600px) {\n.row-product[data-v-3d1a9c60] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      background-color: #f5f5f5;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      height: 100%;\n}\n}\n.product-name[data-v-3d1a9c60] {\n  font-family: \"Avenir Next Bold\";\n  font-size: 14px;\n}\n@media (max-width: 600px) {\n.product-name[data-v-3d1a9c60] {\n      font-size: 12px;\n}\n}\n@media (max-width: 600px) {\n.product-img[data-v-3d1a9c60] {\n    display: none;\n}\n}\n.product-unit-price[data-v-3d1a9c60] {\n  grid-column: 1;\n  grid-row: 2;\n}\n@media (max-width: 600px) {\n.product-unit-price[data-v-3d1a9c60] {\n      font-size: 12px;\n}\n}\n.product-date[data-v-3d1a9c60] {\n  grid-column: 2/4;\n  grid-row: 2;\n  white-space: nowrap;\n}\n@media (max-width: 600px) {\n.product-date[data-v-3d1a9c60] {\n      font-size: 12px;\n      text-align: left;\n}\n}\n.product-actions[data-v-3d1a9c60] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  grid-column: 3;\n  grid-row: 1 / 3;\n  height: 65px;\n  padding: 10px 5px !important;\n}\n@media (max-width: 600px) {\n.product-actions[data-v-3d1a9c60] {\n      border-bottom: none;\n      font-size: 12px;\n}\n}\n.product-actions-wrapper[data-v-3d1a9c60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (max-width: 600px) {\n.row-product[data-v-3d1a9c60] {\n    border: none;\n}\n}\n.product-img[data-v-3d1a9c60] {\n  height: 34px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  width: 50px;\n}\n.action-btn[data-v-3d1a9c60] {\n  margin: 0 10px;\n}\n.section-title[data-v-3d1a9c60] {\n  font-family: \"Avenir Next Bold\";\n  font-size: 16px;\n  margin: 30px 0 40px 40px;\n  text-transform: uppercase;\n}\n@media (max-width: 500px) {\n.section-title[data-v-3d1a9c60] {\n      margin-bottom: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('h3',{staticClass:"section-title",style:(("color: " + (_vm.globalColors.primary) + ";"))},[_vm._v("Mis favoritos")])]),_vm._v(" "),_c('section',{staticClass:"table"},[_c('responsive-table',{attrs:{"align-left":"","columns":_vm.columns,"rows":_vm.getFavorites,"pages":_vm.totalPages},on:{"page-changed":_vm.pageChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('td',{staticClass:"row-product"},[_c('div',{staticClass:"product-info-container"},[_c('img',{staticClass:"product-img",attrs:{"src":row.urlImage,"alt":"imagen del producto"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_c('h4',{staticClass:"product-name"},[_vm._v(_vm._s(row.name))])])])]),_vm._v(" "),_c('td',{staticClass:"product-unit-price"},[_vm._v(_vm._s(row.priceDiscount))]),_vm._v(" "),_c('td',{staticClass:"product-date"},[_vm._v(_vm._s(row.createdAt))]),_vm._v(" "),_c('td',{staticClass:"product-actions"},[_c('div',{staticClass:"product-actions-wrapper"},[_c('car-component',{staticClass:"action-btn",on:{"click":function($event){_vm.buyThisProduct(row)}}}),_vm._v(" "),_c('delete-component',{staticClass:"action-btn",on:{"click":function($event){_vm.noMoreFavorite(row)}}})],1)])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_favorites_vue__ = __webpack_require__(996);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1a9c60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_favorites_vue__ = __webpack_require__(1127);
function injectStyle (ssrContext) {
  __webpack_require__(1125)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d1a9c60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_favorites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1a9c60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_favorites_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function created() {
	this.currentPage = this.page;
	this.arrPageRange = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: this.pageRange }, function (el, i) {
		return i + 1;
	});
}

function calculateColSpan() {
	return this.columns.length;
}

function computedPages() {
	if (this.pages <= this.pageRange) {
		return this.pages;
	}
	return this.currentPage <= this.pageRange ? this.initialPagination() : this.newPagination(this.currentPage);
}

function newPagination(currentPage) {
	if (currentPage >= this.pageRange && this.pages - currentPage < this.pageRange) {
		var init = this.pages - this.pageRange;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: this.pageRange }, function (el, i) {
			return init + i + 1;
		});
	}
	return this.nextRange(currentPage);
}

function initialPagination() {
	return [].concat(this.arrPageRange, '...', this.pages);
}

function changePage(newPage) {
	if (newPage === '...') {
		this.nextRange(this.currentPage, 1);
	} else {
		if (newPage < 1) {
			this.currentPage = 1;
		} else if (newPage > this.pages) {
			this.currentPage = this.pages;
		} else {
			this.currentPage = newPage;
		}
		this.$emit('page-changed', this.currentPage);
	}
}

function nextRange(currentPage, n) {
	var currentRange = Math.ceil(currentPage / this.pageRange) + (n || 0);
	var initial = currentRange * this.pageRange - this.pageRange;
	var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: this.pageRange }, function (el, i) {
		return initial + i + 1;
	});
	if (n) {
		this.currentPage = arr[0];
	}
	return [].concat(arr, '...', this.pages);
}

function page(newPage, oldPage) {
	if (newPage !== oldPage) {
		this.currentPage = newPage;
	}
}

function data() {
	return {
		arrPageRange: null,
		currentPage: 1,
		pageRange: 6
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'responsive-table',
	computed: {
		calculateColSpan: calculateColSpan,
		computedPages: computedPages
	},
	created: created,
	data: data,
	methods: {
		changePage: changePage,
		initialPagination: initialPagination,
		nextRange: nextRange,
		newPagination: newPagination
	},
	props: {
		alignLeft: {
			default: false,
			type: Boolean
		},
		columns: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		page: {
			default: 1,
			type: Number
		},
		pages: {
			default: 0,
			type: [Number, String]
		},
		rows: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		auto: {
			default: false,
			type: Boolean
		},
		tfootHidden: {
			default: true,
			type: Boolean
		}
	},
	watch: {
		page: page
	}
});

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

function clicked() {
	this.$emit('click');
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'delete-component',
	methods: {
		clicked: clicked
	}
});

/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_respondive_table_vue__ = __webpack_require__(826);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66346c90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_respondive_table_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66346c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_respondive_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66346c90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_respondive_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(838);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(761)("1be7ad2c", content, true, {});

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(760)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi\"),url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}table[data-v-66346c90]{border-collapse:collapse;color:#4a4a4a}table[data-v-66346c90],tr[data-v-66346c90]{width:100%}thead[data-v-66346c90]{background-color:#e6e6e6;position:-webkit-sticky;position:sticky;top:75px;z-index:7}thead th[data-v-66346c90]{font-family:Avenir Next Bold;font-size:12px;padding:10px;text-transform:uppercase}@media (max-width:600px){thead .no-responsive[data-v-66346c90]{display:none}}@media (max-width:600px){thead .responsive-col[data-v-66346c90]{display:table-cell;overflow:hidden;text-overflow:ellipsis}}thead th[data-v-66346c90]:first-child{border-bottom-left-radius:8px;border-top-left-radius:8px}thead th[data-v-66346c90]:last-child{border-bottom-right-radius:8px;border-top-right-radius:8px}td[data-v-66346c90]{border-bottom:1px solid #e6e6e6;font-family:Avenir Next Regular;font-size:12px;height:45px;text-align:center}@media (max-width:600px){tfoot.tfoot-hidden[data-v-66346c90]{display:none}}@media (max-width:600px){.grid-system[data-v-66346c90]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:grid;grid-template-columns:repeat(auto-fit,minmax(20px,1fr))}}.grid-system.auto[data-v-66346c90]{border-bottom:1px solid #e6e6e6}.first-column-head[data-v-66346c90]{padding-left:30px;text-align:left}@media (max-width:600px){.first-column-head[data-v-66346c90]{padding:10px;text-align:center}}.pagination-container[data-v-66346c90]{border:none;text-align:right}.pagination[data-v-66346c90]{color:#acaaaa;font-family:Avenir Next Medium;font-size:12px;height:20px;margin:0 5px;text-align:center;width:17px}.active-page[data-v-66346c90]{background-color:#004e9c;color:#fcfcfc}.add-page[data-v-66346c90],.sub-page[data-v-66346c90]{color:#acaaaa;font-family:Avenir Next Medium;font-size:12px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/table/respondive-table.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,uBACE,yBAA0B,AAC1B,aAAe,CAChB,AACD,2CACE,UAAY,CACb,AACD,uBACE,yBAA0B,AAC1B,wBAAyB,AACzB,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,0BACI,6BAAgC,AAChC,eAAgB,AAChB,aAAc,AACd,wBAA0B,CAC7B,AACD,yBACA,sCACM,YAAc,CACnB,CACA,AACD,yBACA,uCACM,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC7B,CACA,AACD,sCACI,8BAA+B,AAC/B,0BAA4B,CAC/B,AACD,qCACI,+BAAgC,AAChC,2BAA6B,CAChC,AACD,oBACE,gCAAiC,AACjC,gCAAmC,AACnC,eAAgB,AAChB,YAAa,AACb,iBAAmB,CACpB,AACD,yBACA,oCACI,YAAc,CACjB,CACA,AACD,yBACA,8BACI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,uDAA2D,CAC9D,CACA,AACD,mCACE,+BAAiC,CAClC,AACD,oCACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACA,oCACM,aAAc,AACd,iBAAmB,CACxB,CACA,AACD,uCACE,YAAa,AACb,gBAAkB,CACnB,AACD,6BACE,cAAe,AACf,+BAAkC,AAClC,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,UAAY,CACb,AACD,8BACE,yBAA0B,AAC1B,aAAe,CAChB,AACD,sDAEE,cAAe,AACf,+BAAkC,AAClC,cAAgB,CACjB","file":"respondive-table.vue","sourcesContent":["\n@font-face {\n  font-family: 'Avenir Next Regular';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Ultra Light';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Ultra Light Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Medium';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Medium Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Demi';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi\"), url(\"/static/fonts/AvenirNextLTPro-Demi.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Demi Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Bold';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Heavy';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Heavy Italic';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: 'Avenir Next Book';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\ntable[data-v-66346c90] {\n  border-collapse: collapse;\n  color: #4a4a4a;\n}\ntable[data-v-66346c90], tr[data-v-66346c90] {\n  width: 100%;\n}\nthead[data-v-66346c90] {\n  background-color: #e6e6e6;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 75px;\n  z-index: 7;\n}\nthead th[data-v-66346c90] {\n    font-family: \"Avenir Next Bold\";\n    font-size: 12px;\n    padding: 10px;\n    text-transform: uppercase;\n}\n@media (max-width: 600px) {\nthead .no-responsive[data-v-66346c90] {\n      display: none;\n}\n}\n@media (max-width: 600px) {\nthead .responsive-col[data-v-66346c90] {\n      display: table-cell;\n      overflow: hidden;\n      text-overflow: ellipsis;\n}\n}\nthead th[data-v-66346c90]:first-child {\n    border-bottom-left-radius: 8px;\n    border-top-left-radius: 8px;\n}\nthead th[data-v-66346c90]:last-child {\n    border-bottom-right-radius: 8px;\n    border-top-right-radius: 8px;\n}\ntd[data-v-66346c90] {\n  border-bottom: 1px solid #e6e6e6;\n  font-family: \"Avenir Next Regular\";\n  font-size: 12px;\n  height: 45px;\n  text-align: center;\n}\n@media (max-width: 600px) {\ntfoot.tfoot-hidden[data-v-66346c90] {\n    display: none;\n}\n}\n@media (max-width: 600px) {\n.grid-system[data-v-66346c90] {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));\n}\n}\n.grid-system.auto[data-v-66346c90] {\n  border-bottom: 1px solid #e6e6e6;\n}\n.first-column-head[data-v-66346c90] {\n  padding-left: 30px;\n  text-align: left;\n}\n@media (max-width: 600px) {\n.first-column-head[data-v-66346c90] {\n      padding: 10px;\n      text-align: center;\n}\n}\n.pagination-container[data-v-66346c90] {\n  border: none;\n  text-align: right;\n}\n.pagination[data-v-66346c90] {\n  color: #acaaaa;\n  font-family: \"Avenir Next Medium\";\n  font-size: 12px;\n  height: 20px;\n  margin: 0 5px;\n  text-align: center;\n  width: 17px;\n}\n.active-page[data-v-66346c90] {\n  background-color: #004e9c;\n  color: #fcfcfc;\n}\n.sub-page[data-v-66346c90],\n.add-page[data-v-66346c90] {\n  color: #acaaaa;\n  font-family: \"Avenir Next Medium\";\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',{staticClass:"table-head"},[_c('tr',{staticClass:"grid-system"},_vm._l((_vm.columns),function(column){return _c('th',{key:column.id,class:[
					column.responsive ? 'responsive-col': 'no-responsive',
					{ 'first-column-head' : _vm.alignLeft } ]},[_vm._v(_vm._s(column.title))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.id,staticClass:"grid-system",class:{'auto': _vm.auto}},[_vm._t("default",null,{row:row})],2)}),0),_vm._v(" "),(_vm.pages > 1)?_c('tfoot',{class:{ 'tfoot-hidden': _vm.tfootHidden }},[_c('tr',[_c('td',{staticClass:"pagination-container",attrs:{"colspan":_vm.calculateColSpan}},[_c('button',{staticClass:"sub-page",attrs:{"type":"button"},on:{"click":function($event){_vm.changePage(_vm.currentPage - 1)}}},[_vm._v("\n\t\t\t\t\t<\n\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.computedPages),function(page){return _c('button',{key:page,class:[
						'pagination',
						{ 'active-page': _vm.currentPage === page } ],attrs:{"type":"button"},on:{"click":function($event){_vm.changePage(page)}}},[_vm._v(_vm._s(page))])}),_vm._v(" "),_c('button',{staticClass:"add-page",attrs:{"type":"button"},on:{"click":function($event){_vm.changePage(_vm.currentPage + 1)}}},[_vm._v(">")])],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_delete_component_vue__ = __webpack_require__(835);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e541438_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_delete_component_vue__ = __webpack_require__(857);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_delete_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e541438_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_delete_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.clicked}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"20","viewBox":"0 0 19 20"}},[_c('g',{attrs:{"fill":"#4A4A4A","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9.5 0C4.262 0 0 4.274 0 9.528c0 5.254 4.262 9.528 9.5 9.528S19 14.782 19 9.528C19 4.274 14.738 0 9.5 0zm0 17.423c-4.34 0-7.871-3.542-7.871-7.895S5.159 1.633 9.5 1.633c4.34 0 7.871 3.542 7.871 7.895s-3.53 7.895-7.871 7.895z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.845 6.173a.74.74 0 0 0-1.048 0L9.5 8.477 7.203 6.173a.74.74 0 0 0-1.048 0c-.29.29-.29.76 0 1.05l2.297 2.305-2.297 2.304a.744.744 0 0 0 .524 1.27c.19 0 .38-.073.524-.219L9.5 10.58l2.297 2.304a.738.738 0 0 0 1.048 0c.29-.29.29-.76 0-1.05l-2.297-2.305 2.297-2.304c.29-.29.29-.76 0-1.051z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_icons_car_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_icons_delete_component__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_table_respondive_table__ = __webpack_require__(836);




var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$store.dispatch('LOAD_FAVORITES_PRODUCTS', { context: this, params: this.params });

					case 2:
						this.totalPages = _context.sent;

					case 3:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var noMoreFavorite = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(product) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$store.dispatch('SET_FAVORITE_FLAG', { context: this, product: product });

					case 2:
						this.$store.dispatch('LOAD_FAVORITES_PRODUCTS', { context: this, params: this.params });

					case 3:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function noMoreFavorite(_x) {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function buyThisProduct(product) {
	this.$store.dispatch('addProductToBuyCar', product);
	this.goTo('buy');
}

function pageChange(page) {
	this.params.page = page;
	this.$store.dispatch('LOAD_FAVORITES_PRODUCTS', { context: this, params: this.params });
}

function data() {
	return {
		columns: [{ value: 'product', title: 'Producto', responsive: false }, { value: 'unitPrice', title: 'Precio Und', responsive: true }, { value: 'createdAt', title: 'Fecha de Creación', responsive: true }, { value: 'actions', title: 'Acción', responsive: true }],
		params: {
			page: 1,
			limit: 5
		},
		totalPages: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'favorites',
	components: {
		carComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_icons_car_component__["a" /* default */],
		deleteComponent: __WEBPACK_IMPORTED_MODULE_5__components_shared_icons_delete_component__["a" /* default */],
		responsiveTable: __WEBPACK_IMPORTED_MODULE_6__components_shared_table_respondive_table__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getFavorites'])),
	created: created,
	data: data,
	methods: {
		buyThisProduct: buyThisProduct,
		noMoreFavorite: noMoreFavorite,
		pageChange: pageChange
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.530a0f9487a8ccd97233.js